import React from 'react';
import { useEffect, useState } from 'react';
import { API_HOST } from '../../consts';
import axios from 'axios';
import ReportGraphLine from './ReportGraphLine';
import { useContext } from 'react';
import HeaderClass from '../../components/HeaderClass';
import { Grid } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import HelpOutlinedIcon from '@material-ui/icons/HelpOutlined';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import { withTheme } from 'styled-components';
import { FilterRelatorioContext } from '../../contexts/FilterRelatorioProvider/Context';
import ReportProficiencyScalePageButtons from './ReportProficiencyScalePageButtons';

const ComparativeClasses = () => {
  const [nameDre, setnameDre] = useState(undefined);
  const [nameEscola, setnameEscola] = useState(undefined);
  const { filtrosRelatorios, setStateFilters } = useContext(FilterRelatorioContext)

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_HOST}/avalia/dre?id=${filtrosRelatorios.dreId}`
        );
        const data = response.data;
        setnameDre(data[0].dre_name);
        const responseEscola = await axios.get(
          `${API_HOST}/avalia/escola?cd_escola=${filtrosRelatorios.currentEscola}`
        );
        setnameEscola(responseEscola.data[0].nm_escola);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);

  const etapa_name = {
    2: 'EF 2º ano',
    3: 'EF 3º ano',
    4: 'EF 4º ano',
    5: 'EF 5º ano',
    6: 'EF 6º ano',
    7: 'EF 7º ano',
    8: 'EF 8º ano',
    9: 'EF 9º ano',
    11: 'EM 1ª série',
    12: 'EM 2ª série',
    13: 'EM 3ª série'
  };

  const disciplina_name = {
    1: 'Linguagens',
    2: 'Matemática',
    3: 'Ciências da Natureza',
    4: 'Ciências Humanas'
  };

  const Accordion = withStyles({
    root: {
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderBottom: 0
      },
      '&:before': {
        display: 'none'
      },
      '&$expanded': {
        marginTop: '10px',
        marginBottom: '10px',
        margin: 'auto'
      },
      '& .MuiPaper-root': {
        backgroundColor: 'none'
      }
    },
    expanded: {}
  })(MuiAccordion);

  const AccordionSummary = withStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: 'rgb(106, 53, 221)',
      border: 'none',
      borderRadius: '16px',
      height: '42px',
      boxShadow: '0px 0px 4.94866px rgba(0, 0, 0, 0.25)',
      marginBottom: '10px',
      '&$expanded': {
        minHeight: 56
      }
    },
    content: {
      '&$expanded': {
        margin: '12px 0'
      }
    },
    expanded: {}
  })(MuiAccordionSummary);

  const AccordionDetails = withStyles((theme) => ({
    root: {
      backgroundColor: '#FFFFFF',
      padding: theme.spacing(2),
      border: '1px solid #F7F7F7',
      borderRadius: '8px'
    }
  }))(MuiAccordionDetails);

  return (
    <>
      <div
        className="card-header"
        style={{
          width: '100%',
          marginBottom: '-0.7rem',
          backgroundColor: '#f7f7f7',
          borderRadius: '10px'
        }}
      >
        <h1
          style={{
            fontFamily: 'Quicksand',
            fontSize: '24px',
            color: '#292929',
            fontWeight: 'bold'
          }}
        >
          Relatório Comparativo entre turmas
        </h1>
        <span
          style={{
            fontSize: '14px',
            color: '#292929',
            fontWeight: 500,
            fontFamily: 'Quicksand'
          }}
        >
          {/* Distribuição Percentual dos Estudantes nos Níveis da
                      Escala de Proficiência */}
        </span>
        <hr
          style={{
            background: '#bebebe',
            width: '100%',
            height: '1px',
            borderRadius: '1px'
          }}
        />
      </div>
      <div
        className="card-body"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          style={{ marginTop: '.7rem', background: 'none' }}
        >
          <Accordion
            defaultExpanded
            style={{
              backgroundColor: 'none'
            }}
          >
            <AccordionSummary
              expandIcon={
                <ArrowDropDownIcon
                  style={{ fontSize: '2.5rem', color: '#fff' }}
                />
              }
              aria-controls="panel1d-content"
              id="panel1d-header"
            >
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                <label
                  className="mt-2"
                  style={{
                    color: '#FFFFFF',
                    fontFamily: 'Quicksand',
                    fontWeight: '700',
                    fontSize: '19px',
                    marginRight: '5px'
                  }}
                >
                  Comparação de proficiência entre turmas por
                  Componente Curricular
                </label>
                <HelpOutlinedIcon style={{ fontSize: '19px' }} />
              </div>
            </AccordionSummary>
            <Grid item container xs={12} sm={12} md={12}>
              <div
                style={{
                  marginTop: '1.0rem',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <div
                  style={{
                    width: '98%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                ></div>
              </div>
            </Grid>

            <AccordionDetails>
              <Grid container spacing={2}>
                <Grid item container xs={12} sm={12} md={12}>
                  <HeaderClass
                    schoolYear={etapa_name[`${filtrosRelatorios.dadosEtapaEscolar}`]}
                    schoolName={nameEscola}
                    dreAndMunicipio={nameDre}
                  />
                </Grid>
                <Grid item container xs={12} sm={12} md={12}>
                  <Grid item xs={12}>
                    <p
                      style={{
                        fontSize: '14px',
                        fontWeight: '400',
                        fontFamily: 'Quicksand',
                        color: '#565656'
                      }}
                    ></p>
                  </Grid>
                  <Grid item xs={12}>
                    <ReportGraphLine
                      tipo={'dre-turmas'}
                      dre={filtrosRelatorios.dreId}
                      etapa={filtrosRelatorios.dadosEtapaEscolar}
                      ano={filtrosRelatorios.periodoAno}
                      disciplina={filtrosRelatorios.DisciplinaID}
                      escola={filtrosRelatorios.currentEscola}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
        </Grid>
        <ReportProficiencyScalePageButtons />
      </div>
    </>
  );
};

export default withTheme(ComparativeClasses);
